import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.filter;

export const filterSelectors = {
  filters: createSelector(selector, (state) => state.filters),
};
